// Lazy-loaded entry to the Pixi battle renderer — the shared mount
// point for App routes, SoloPlayScreen, and MultiPlayScreen. Keeps
// pixi.js + gsap (~450KB min) in their own chunk: title/shop-only
// sessions never download the WebGL renderer; the chunk fetches the
// moment a battle mounts (alongside texture preloading).

import { lazy, Suspense, type ReactElement } from 'react'
import type { BattleResult } from '@origami/shared'
import type { BattleMeta } from '../ui/BattleScreen'

const Inner = lazy(() =>
  import('./PixiBattleScreen').then((m) => ({ default: m.PixiBattleScreen })),
)

export function PixiBattle(props: {
  battle?: BattleResult
  meta?: BattleMeta
  onExit?: () => void
}): ReactElement {
  return (
    <Suspense
      fallback={
        <div
          className="paper"
          style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'var(--serif)',
            fontStyle: 'italic',
            fontSize: 22,
            color: 'var(--ink-fade)',
          }}
        >
          unrolling the stage…
        </div>
      }
    >
      <Inner {...props} />
    </Suspense>
  )
}
